export const apiStatusCodeEnum = {
    success: 200
}
